import { InfoTooltip } from '../InfoTooltip.js';
import { METRIC_EXPLANATIONS, getConfidenceLabel } from '../../data/metric-explanations.js';

export interface ConfidencePanelData {
  confidence: number;
  confidenceLevel?: string;
  providersRespondedCount?: number;
  providersAttemptedCount?: number;
}

export function ConfidencePanel({ data }: { data: ConfidencePanelData | null | undefined }) {
  const d = data ?? null;

  if (d == null || typeof d.confidence !== 'number') {
    return null;
  }

  const cl = getConfidenceLabel(d.confidence);

  return (
    <div className="dash-card ws-forensic-section">
      <h3 className="ws-forensic-title" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        Analysis Reliability
        <InfoTooltip explain={METRIC_EXPLANATIONS.confidence} compact />
      </h3>
      <div className="intel-grid intel-grid-3">
        <div className="intel-metric-card card">
          <div className="intel-metric">
            <span className="intel-metric-label">Confidence Score</span>
            <span className="intel-metric-value" style={{ color: cl.color }}>
              {Math.round(d.confidence)}%
            </span>
          </div>
          <div style={{ marginTop: '0.5rem', height: 6, borderRadius: 3, background: 'rgba(255,255,255,0.08)', overflow: 'hidden' }}>
            <div style={{ width: `${d.confidence}%`, height: '100%', borderRadius: 3, background: cl.color, transition: 'width 0.5s ease' }} />
          </div>
        </div>
        <div className="intel-metric-card card">
          <div className="intel-metric">
            <span className="intel-metric-label">Confidence Level</span>
            <span className="intel-metric-value" style={{ color: cl.color }}>
              {cl.label}
            </span>
          </div>
        </div>
        {(d.providersRespondedCount != null || d.providersAttemptedCount != null) && (
          <div className="intel-metric-card card">
            <div className="intel-metric">
              <span className="intel-metric-label">Providers</span>
              <span className="intel-metric-value">
                {d.providersRespondedCount ?? 0} / {d.providersAttemptedCount ?? 0}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
